import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/common.json";
import ptbr from "./locales/ptbr/common.json";

i18n.use(LanguageDetector).init({
  lng: "en", // Idioma padrão
  fallbackLng: "en", // Idioma padrão
  supportedLngs: ["en", "ptbr"], // Idiomas suportados
  detection: {
    order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
    caches: ["cookie"],
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
  },
  resources: {
    en,
    ptbr,
  },
});

export default i18n;
